<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { addUserPoints } from "./api";

const router = useRouter();
const saving = ref(false);
const error = ref("");
const success = ref("");
const rows = ref([{ customer_id: "", points: "" }]);

function addRow() { rows.value.push({ customer_id: "", points: "" }); }
function removeRow(i) { rows.value.splice(i, 1); }

async function submit() {
  error.value = ""; success.value = "";
  const valid = rows.value.filter((r) => r.customer_id.trim() && r.points);
  if (!valid.length) { error.value = "Add at least one row."; return; }
  saving.value = true;
  try {
    for (const r of valid) { await addUserPoints({ customer_id: r.customer_id.trim(), points: Number(r.points) }); }
    success.value = `${valid.length} points row(s) submitted.`;
    rows.value = [{ customer_id: "", points: "" }];
  } catch { error.value = "Error submitting points."; }
  finally { saving.value = false; }
}
</script>

<template>
  <section>
    <VBtn variant="text" prepend-icon="mdi:arrow-left" class="mb-4" @click="router.push({ name: 'users' })">Back</VBtn>
    <h1 class="text-h5 mb-4">Batch Add User Points</h1>
    <VCard class="pa-4" max-width="700">
      <VAlert v-if="error" type="error" class="mb-4">{{ error }}</VAlert>
      <VAlert v-if="success" type="success" class="mb-4">{{ success }}</VAlert>
      <VTable density="compact" class="mb-4">
        <thead><tr><th>Employee No.</th><th>Points</th><th></th></tr></thead>
        <tbody>
          <tr v-for="(row, i) in rows" :key="i">
            <td><VTextField v-model="row.customer_id" density="compact" hide-details placeholder="e.g. EMP001" /></td>
            <td><VTextField v-model.number="row.points" density="compact" hide-details type="number" placeholder="e.g. 100" /></td>
            <td><VBtn icon="mdi:close" size="small" variant="text" color="error" @click="removeRow(i)" /></td>
          </tr>
        </tbody>
      </VTable>
      <div class="d-flex gap-2">
        <VBtn variant="tonal" prepend-icon="mdi:plus" @click="addRow">Add Row</VBtn>
        <VBtn :loading="saving" @click="submit">Submit Points</VBtn>
      </div>
    </VCard>
  </section>
</template>
